import { getData } from "./index.svc"

export const getLaborByJobNumber = async (jobNumber, showAll = false) => {
    const qs = showAll ? '?all=1' : ''
    return await getData(`jobs/${jobNumber}/labor${qs}`)
}

export const createJobLabor = async (body) => await getData(`jobs/${body.JobNumber}/labor`, 'POST', body)

export const updateJobLabor = async (body) => await getData(`jobs/${body.JobNumber}/labor/${body.ID}`, 'POST', body)

export const deleteJobLabor = async (labor) => await getData(`jobs/${labor.JobNumber}/labor/${labor.ID}?Active=No`, 'DELETE')

export const resetJobLabor = async (labor) => await getData(`jobs/${labor.JobNumber}/labor/${labor.ID}?Active=Yes`, 'DELETE')